// Relative path for same-origin API calls (eliminates CORS issues in Safari)
export const API_URL = '';

export const GENERATOR_CATEGORIES = {
  aktion: [
    { id: 'stehend', label: 'Stehend', sensual: false },
    { id: 'stehend_s', label: 'Stehend', sensual: true },
    { id: 'sitzend', label: 'Sitzend', sensual: false },
    { id: 'sitzend_s', label: 'Sitzend', sensual: true },
    { id: 'liegend', label: 'Liegend', sensual: false },
    { id: 'liegend_s', label: 'Liegend', sensual: true },
    { id: 'training', label: 'Beim Training', sensual: false },
    { id: 'training_s', label: 'Beim Training', sensual: true },
    { id: 'laufend', label: 'Laufend', sensual: false },
    { id: 'laufend_s', label: 'Laufend', sensual: true }
  ],
  koerper: [
    { id: 'ruecken', label: 'Rückenansicht', sensual: false },
    { id: 'ruecken_s', label: 'Rückenansicht', sensual: true },
    { id: 'vorder', label: 'Vorderansicht', sensual: false },
    { id: 'vorder_s', label: 'Vorderansicht', sensual: true },
    { id: 'ganz', label: 'Ganzer Körper', sensual: false },
    { id: 'ganz_s', label: 'Ganzer Körper', sensual: true }
  ],
  kleidung: [
    { id: 'sommerkleid', label: 'Sommerkleid', sensual: false },
    { id: 'sommerkleid_s', label: 'Sommerkleid', sensual: true },
    { id: 'bikini', label: 'Bikini', sensual: false },
    { id: 'bikini_s', label: 'Bikini', sensual: true },
    { id: 'dessous', label: 'Dessous', sensual: false },
    { id: 'dessous_s', label: 'Dessous', sensual: true },
    { id: 'rock', label: 'Rock', sensual: false },
    { id: 'rock_s', label: 'Rock', sensual: true },
    { id: 'jeans', label: 'Jeans', sensual: false },
    { id: 'jeans_s', label: 'Jeans', sensual: true },
    { id: 'mantel', label: 'Mantel', sensual: false },
    { id: 'mantel_s', label: 'Mantel', sensual: true },
    { id: 'pyjama', label: 'Pyjama', sensual: false },
    { id: 'pyjama_s', label: 'Pyjama', sensual: true },
    { id: 'tanktop', label: 'Tanktop', sensual: false },
    { id: 'tanktop_s', label: 'Tanktop', sensual: true },
    { id: 'sport', label: 'Sportkleidung', sensual: false },
    { id: 'sport_s', label: 'Sportkleidung', sensual: true },
    { id: 'regenmantel', label: 'Regenmantel', sensual: false },
    { id: 'regenmantel_s', label: 'Regenmantel', sensual: true },
    { id: 'hoodie', label: 'Hoodie', sensual: false },
    { id: 'hoodie_s', label: 'Hoodie', sensual: true },
    { id: 'jacke', label: 'Jacke', sensual: false },
    { id: 'jacke_s', label: 'Jacke', sensual: true },
    { id: 'kaeppi', label: 'Käppi', sensual: false },
    { id: 'kaeppi_s', label: 'Käppi', sensual: true }
  ],
  szene: [
    { id: 'garten', label: 'Garten', sensual: false },
    { id: 'garten_s', label: 'Garten', sensual: true },
    { id: 'fitness', label: 'Fitnessstudio', sensual: false },
    { id: 'fitness_s', label: 'Fitnessstudio', sensual: true },
    { id: 'wald', label: 'Wald', sensual: false },
    { id: 'wald_s', label: 'Wald', sensual: true },
    { id: 'strand', label: 'Strand', sensual: false },
    { id: 'strand_s', label: 'Strand', sensual: true },
    { id: 'hotel', label: 'Hotelzimmer', sensual: false },
    { id: 'hotel_s', label: 'Hotelzimmer', sensual: true },
    { id: 'wohnzimmer', label: 'Wohnzimmer', sensual: false },
    { id: 'wohnzimmer_s', label: 'Wohnzimmer', sensual: true },
    { id: 'dusche', label: 'Dusche', sensual: false },
    { id: 'dusche_s', label: 'Dusche', sensual: true }
  ],
  accessoires: [
    { id: 'halskette', label: 'Halskette', sensual: false },
    { id: 'halskette_s', label: 'Halskette', sensual: true },
    { id: 'brille', label: 'Brille', sensual: false },
    { id: 'brille_s', label: 'Brille', sensual: true },
    { id: 'hut', label: 'Hut', sensual: false },
    { id: 'hut_s', label: 'Hut', sensual: true },
    { id: 'cap', label: 'Baseball-Cap', sensual: false },
    { id: 'cap_s', label: 'Baseball-Cap', sensual: true },
    { id: 'armband', label: 'Armband', sensual: false },
    { id: 'armband_s', label: 'Armband', sensual: true },
    { id: 'ohrringe', label: 'Ohrringe', sensual: false },
    { id: 'ohrringe_s', label: 'Ohrringe', sensual: true }
  ],
  ansicht: [
    { id: 'nah', label: 'Nahaufnahme', sensual: false },
    { id: 'nah_s', label: 'Nahaufnahme', sensual: true },
    { id: 'oben', label: 'Von oben', sensual: false },
    { id: 'oben_s', label: 'Von oben', sensual: true },
    { id: 'hinten', label: 'Von hinten', sensual: false },
    { id: 'hinten_s', label: 'Von hinten', sensual: true },
    { id: 'halbportrait', label: 'Halbportrait', sensual: false },
    { id: 'halbportrait_s', label: 'Halbportrait', sensual: true },
    { id: 'weitwinkel', label: 'Weitwinkel', sensual: false },
    { id: 'weitwinkel_s', label: 'Weitwinkel', sensual: true }
  ]
};

// German to English translations for prompts
export const TRANSLATIONS = {
  // Aktion
  stehend: 'standing',
  sitzend: 'sitting',
  liegend: 'lying down',
  training: 'working out',
  laufend: 'running',
  // Körper
  ruecken: 'back view',
  vorder: 'front view',
  ganz: 'full body',
  // Kleidung
  sommerkleid: 'summer dress',
  bikini: 'bikini',
  dessous: 'lingerie',
  rock: 'skirt',
  jeans: 'jeans',
  mantel: 'coat',
  pyjama: 'pajamas',
  tanktop: 'tank top',
  sport: 'sportswear',
  regenmantel: 'raincoat',
  hoodie: 'hoodie',
  jacke: 'jacket',
  kaeppi: 'cap',
  // Szene
  garten: 'in a garden',
  fitness: 'in a gym',
  wald: 'in a forest',
  strand: 'at the beach',
  hotel: 'in a hotel room',
  wohnzimmer: 'in a living room',
  dusche: 'in a shower',
  // Accessoires
  halskette: 'wearing a necklace',
  brille: 'wearing glasses',
  hut: 'wearing a hat',
  cap: 'wearing a baseball cap',
  armband: 'wearing a bracelet',
  ohrringe: 'wearing earrings',
  // Ansicht
  nah: 'close-up shot',
  oben: 'from above',
  hinten: 'from behind',
  halbportrait: 'half portrait',
  weitwinkel: 'wide angle'
};